// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'

import './scss/mainWidget.scss'
// import './scss/style.css'

export const serverBus = new Vue()

let cssId = 'widgetId'
if (!document.getElementById(cssId)) {
  let head = document.getElementsByTagName('head')[0]
  let link = document.createElement('link')
  const urlLink = new URL(document.location)
  const domain = urlLink.origin
  let url = process.env.NODE_ENV === 'development' ? '' : `${domain}/pre-chat/app/ask/`
  link.id = cssId
  link.rel = 'stylesheet'
  link.type = 'text/css'
  link.href = url + 'css/widget.css'
  link.media = 'all'
  head.appendChild(link)
}

window.askwidget = {
  open: function (type) {
    serverBus.$emit('openingWidget')
    // eslint-disable-next-line no-undef,no-constant-condition
    if (typeof LiveChatWidget === 'object') {
      // eslint-disable-next-line no-undef
      LiveChatWidget.call('maximize')
    }
    if (type) Vue.prototype.$linkedButton = type
  },
  close: function () {
    serverBus.$emit(('apiCloseWidget'))
  },
  reload: function () {
    serverBus.$emit(('reloadWidget'))
  }
}

export const globalState = Vue.observable({
  visibleOfLiveChat: false
})

/* eslint-disable no-new */
new Vue({
  el: '#app_ask',
  render (h) {
    return h(App)
  }
})



// WEBPACK FOOTER //
// ./src/main.js